/** Formata telefone brasileiro: (11) 94729-3221 ou (11) 4729-3221 */
export function formatBrazilPhone(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) return digits.length ? `(${digits}` : "";
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function phoneDigits(value: string): string {
  return value.replace(/\D/g, "");
}

/** Celular (11) ou fixo (10) com DDD. */
export function isValidBrazilPhone(value: string): boolean {
  const digits = phoneDigits(value);
  return digits.length === 10 || digits.length === 11;
}

export function getStoredPhone(data: {
  phone?: string;
  telefone?: string;
  whatsapp?: string;
}): string {
  return data.phone || data.telefone || data.whatsapp || "";
}
